// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"3011":"AddNewStaffs","4354":"addbusiness","5521":"addcars","7615":"addproperty"}[chunkId] + "." + {"3011":"f5c70393","4354":"63960900","5521":"63960900","7615":"63960900"}[chunkId] + ".css";
};